// jshint esversion: 8
import ApiFactory from '@/api/ApiFactory';
import amplitude from 'amplitude-js';
const DatesApi = ApiFactory.get('dates');

const fetchAll = async ( { commit }, qs ) => {
  const { data } = await DatesApi.getAll(qs);
  commit("SET_DATA", data);
};

const create = async ( { commit }, payload ) => {
  const { data } = await DatesApi.post(payload);
  amplitude.getInstance().logEvent('CREATE_DATE');
  commit("PUSH_DATA", data);
};

const update = async ( { commit }, payload) => {
  const { data } = await DatesApi.update(payload.id, payload);
  amplitude.getInstance().logEvent('UPDATE_DATE');
  commit('UPDATE_BY_ID', data);
};

export default {
  fetchAll,
  create,
  update
};
